<template>
  <div class="container">
    <div class="left">
      <div class="text-container">
        <h1 class="medium-h1 gradient-text">{{$t('workCards.title')}}</h1>
        <p class="">{{$t('workCards.description')}}</p>
        <router-link to="/works">
          <ButtonComponent :msg="$t('workCards.button')" />
        </router-link>
      </div>

      <div class="img-container">
        <img
          class="img1"
          :src="require(`@/assets/img_page_work/${projects[0].image}`)"
          @click="goToWorkDetail(projects[0].slug)"
          :alt="getProjectTitle(projects[0])"
        />
        <div class="project-text">
          <h2>{{ getProjectTitle(projects[0]) }}</h2>
          <p>{{ getProjectDescription(projects[0]) }}</p>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="img-container">
        <img
          class="img2"
          :src="require(`@/assets/img_page_work/${projects[1].image}`)"
          @click="goToWorkDetail(projects[1].slug)"
          :alt="getProjectTitle(projects[1])"
        />
        <div class="project-text">
          <h2>{{ getProjectTitle(projects[1]) }}</h2>
          <p>{{ getProjectDescription(projects[1]) }}</p>
        </div>
      </div>
      <div class="img-container">
        <img
          class="img3"
          :src="require(`@/assets/img_page_work/${projects[2].image}`)"
          @click="goToWorkDetail(projects[2].slug)"
          :alt="getProjectTitle(projects[2])"
        />
        <div class="project-text">
          <h2>{{ getProjectTitle(projects[2]) }}</h2>
          <p>{{ getProjectDescription(projects[2]) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from './ButtonComponent.vue';
import projects from '../data/projects.json';

export default {
  name: 'WorkCards',
  props: {
    projects: {
      type: Array,
      default: () => projects,
    },
  },
  components: {
    ButtonComponent
  },
  methods: {
    goToWorkDetail(slug) {
      this.$router.push(`/works/${slug}`);
    },
    getProjectTitle(project) {
      return this.$i18n.locale === 'fr' ? (project.title_fr || project.title) : project.title;
    },
    getProjectDescription(project) {
      return this.$i18n.locale === 'fr' ? (project.description_fr || project.description) : project.description;
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  display: flex;
  justify-content: center;
  width: 90%;
  gap: 20px;
}

.left {
/*   width: 50%; */
  display: flex;
  flex-direction: column;
  gap:20px;
}

.right {
/*   width: 50%; */
  display: flex;
  flex-direction: column;
  align-items: start;
}

.img-container {
  max-width: 570px;
  filter: grayscale(100%);
  cursor: pointer;
}
.img-container:hover {
  filter: grayscale(0);
}
.img1 {
  width: 100%;
    border-radius: 30px;
/*   background-image: url("@/assets/mockup1.webp"); */
}
.img2 {
  width: 100%;
    border-radius: 30px;
/*   background-image: url("@/assets/mockup2.webp"); */
  margin-bottom: 20px;
}
.img3 {
  width: 100%;
    border-radius: 30px;
/*   background-image: url("@/assets/mockup3.webp"); */
}

.text-container {
  max-width: 570px;
  height: fit-content;
}

/* 
@media only screen and (max-width: 1300px) {
  .img-container {
    width: 499px;
    height: 626px;
  }
}
@media only screen and (max-width: 1100px) {
  .img-container {
    width: 430px;
    height: 539px;
  }
}
@media only screen and (max-width: 920px) {
  .img-container {
    width: 381px;
    height: 477px;
  }
} */
@media only screen and (max-width: 850px) {
  .container {
    flex-direction: column;
    align-items: center;
  }
  .left {
    align-items: center;
  }
  .right {
    align-items: center;
  }
}
</style>
